import config from 'config';

function getFableticsCategoryNav(region, startPath) {
  switch (region) {
    case 'EU':
      switch (startPath) {
        case 'scrubs':
          return config.get('public.brand.navigation.categoryNavScrubs');
        case 'mens':
          return config.get('public.brand.navigation.categoryNavMensEU');
        default:
          return config.get('public.brand.navigation.categoryNavWomensEU');
      }
    default:
      switch (startPath) {
        case 'scrubs':
          return config.get('public.brand.navigation.categoryNavScrubs');
        case 'mens':
          return config.get('public.brand.navigation.categoryNavMens');
        default:
          return config.get('public.brand.navigation.categoryNavWomens');
      }
  }
}

function getSavageXFentyNav({ region, startPath, secondPath }) {
  // Check for men's navigation patterns - Savage uses 'men' not 'mens'
  const isMensPath =
    startPath === 'men' || (startPath === 'products' && secondPath === 'men');

  // Use SXF-specific nav containers for both NA and EU regions
  if (isMensPath) {
    return region === 'EU'
      ? config.get('public.brand.navigation.categoryNavMensEU')
      : config.get('public.brand.navigation.categoryNavMens');
  } else {
    return region === 'EU'
      ? config.get('public.brand.navigation.categoryNavWomensEU')
      : config.get('public.brand.navigation.categoryNavWomens');
  }
}

export function getCategoryNavContainer(region, asPath) {
  if (!asPath) {
    return null;
  }

  const startPath = asPath.split('/')[1];
  const secondPath = asPath.split('/')[2];
  switch (config.public.brand.name) {
    // TODO: MOVE THESE BRAND VARIABLES TO A CONSTANTS FILE, SAME WITH REGIONS
    case 'yitty':
      return config.get('public.brand.navigation.categoryNav');
    case 'fabletics':
      return getFableticsCategoryNav(region, startPath);
    case 'savage':
      return getSavageXFentyNav({ region, startPath, secondPath });
  }
  return '';
}
